import { z } from "zod";
import { mediaSchema } from "../zod/mediaSchema.js";
import { nonEmptyString } from "../zod/nonEmptyString.js";

export const imageTextBlockSchema = z.object({
	image: mediaSchema,
	html: nonEmptyString,
	reversed: z.boolean(),
});
